<template>
  <v-select
    label="Departure Date"
    :items="items"
    v-model="departureDate"
    :outlined="outlined"
    item-text="label"
    item-value="value"
    @change="onChange"
    :multiple="multi"
  ></v-select>
</template>

<script>
const moment = require("moment");
export default {
  name: "template-departure-date-select",

  props: {
    value: {
      type: String,
      default: () => "",
    },
    departures: {
      type: Array,
      default: () => [],
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    multi: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      departureDate: this.value ? this.value : [],
    };
  },

  watch: {
    value(newVal) {
      this.departureDate = newVal;
    },
  },

  computed: {
    items() {
      const dates = [];
      for (const d of this.departures) {
        const from = moment(d.validFrom);
        const to = moment(d.validTo);
        const daysOfWeek = d.daysOfWeek.split(",");
        for (
          const m = moment(from);
          m.diff(to, "days") <= 0;
          m.add(1, "days")
        ) {
          if (daysOfWeek.indexOf(m.day().toString()) > -1) {
            const date = {
              value: m.toISOString(true),
              label: `${this.$options.filters.formatDate(
                m.toISOString(true)
              )} - ${m.format("dddd")}`,
            };
            if (dates.indexOf(date) == -1) {
              dates.push(date);
            }
          }
        }
      }

      return dates;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.departureDate);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateDepartureDateSelect.vue